<template>
	<v-card
			width="98px"
			outlined
			class="lot-chk-card"
			:disabled="!podeAlocar"
			:class="[{
	        disabled: !podeAlocar,
	        active: isActive,
	      }]"
			@click="onCardClick"
	>
		<v-container fluid class="pa-1">
			<v-row class="ma-0 d-flex">
				<div class="input-chk">
					<input ref="chk" v-model="lazyValue" type="checkbox" :value="trueValue" />
					<span class="mark">
            <v-icon v-if="isActive" x-small>fas fa-check-square</v-icon>
            <v-icon v-else x-small>far fa-square</v-icon>
          </span>
				</div>
				<v-spacer />
				<span class="date-text mr-1 text-capitalize">
          {{
						trueValue.dtAlocado | formataData(true, 'ddd - DD/MM')
          }}
        </span>
			</v-row>
			<v-row align="center" justify="start" class="ma-0 px-0 pt-2 pb-1">
				<span class="weight-text">{{ qtVazioSanitario > 0 ? qtVazioSanitario : '--' }}</span>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import moment from "moment"

export default {
	name: "AlocarLotesCheckbox",
	model: {
		prop: "inputValue",
		event: "change",
	},
	props: {
		podeAlocar: {
			type: Boolean,
			required: true,
		},
		inputValue: {
			type: Array,
			required: true,
		},
		trueValue: {
			type: Object,
			required: true,
		},
		dtInicioVazio: String
	},
	data() {
		return {
			lazyValue: this.inputValue,
		};
	},
	filters: {
		formataData(date, ISO, formatoSaida) {
			let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD'
			const parsedDate = moment(date, tipoData)
			if (!parsedDate.isValid()) return ""
			return parsedDate.format(formatoSaida)
		},
	},
	computed: {
		qtVazioSanitario() {
			return moment(this.trueValue.dtAlocado, 'YYYY-MM-DD').diff(moment(this.dtInicioVazio,'YYYY-MM-DD'), 'days')
		},
		isActive() {
			const idx = this.inputValue.findIndex((item) => item.dtAlocado === this.trueValue.dtAlocado
					&& item.id === this.trueValue.id)
			return idx > -1
		},
	},
	methods: {
		onCardClick() {
			this.$refs["chk"].click();
		},
	},
	watch: {
		inputValue: {
			deep: true,
			handler(newValue) {
				this.lazyValue = newValue || null;
			},
		},
		lazyValue(newValue) {
			this.$emit("change", newValue);
		},
	},
};
</script>

<style scoped lang="scss">
.lot-chk-card {
  background: #87e2d129 0 0 no-repeat padding-box;
  border: 1px solid #33d6ab80;
  border-radius: 4px;
  transition: all 150ms ease-in-out;

  .date-text {
    font: normal normal normal 10px/13px Roboto;
    letter-spacing: 0;
    color: #7b9596;
  }

  .weight-text {
    font: normal normal bold 14px/20px Roboto;
    letter-spacing: 0;
    color: #0ca5a2;
	  white-space: nowrap;

    &:after {
      content: " dias de vazio";
      margin-left: 2px;
      font: normal normal normal 10px/10px Roboto;
      letter-spacing: 0;
      color: #7b9596;
    }
  }

  .input-chk {
    display: flex;
    position: relative;

    input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      height: 0;
      width: 0;
    }

    .mark {
      i {
        color: #2bc1b6;
        background: #2bc1b6;
        opacity: 0.4;
      }

      display: flex;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.disabled {
    background: #f2f5f3 0 0 no-repeat padding-box;
    border: 1px solid transparent;
    border-radius: 4px;

    .date-text {
      color: #bdccca;
    }

    .weight-text {
      color: #7b9596;

      &:after {
        color: #bdccca;
      }
    }

    .mark {
      i {
        color: #bdccca;
        opacity: 0.4;
        background: #bdccca;
      }
    }
  }

  &:hover {
    background: #33d6ab 0 0 no-repeat padding-box;
    box-shadow: 0 4px 8px #19a5a23d;
    border: 1px solid #33d6ab;

    .date-text {
      color: #f2f5f3;
    }

    .weight-text {
      color: #ffffff;

      &:after {
        color: #f2f5f3;
      }
    }
  }

  &.active {
    background: #0ca5a2 0 0 no-repeat padding-box;
    box-shadow: 0 4px 8px #19a5a23d;
    border: 1px solid #0ca5a2;

    .date-text {
      color: #f2f5f3;
    }

    .weight-text {
      color: #ffffff;

      &:after {
        color: #f2f5f3;
      }
    }

    .mark {
      i {
        color: #ffffff;
        opacity: 1;
      }
    }
  }

  &.grace-period:not(.active) {
    background: #f2f5f3 0 0 no-repeat padding-box;
    border: 1px solid #f5b800;

    .date-text {
      color: #bdccca;
    }

    .weight-text {
      color: #7b9596;

      &:after {
        color: #bdccca;
      }
    }

    .mark {
      i {
        color: #f5b800;
        background: unset;
        opacity: 1;
      }
    }
  }
}
</style>
